import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { OfficeWithPersona } from "@/models/goFurther";
import { FONT_SIZE, FONT_WEIGHT, TEXT_COLOR } from "../GoFurtherStyles";
import { OfficeSelector } from "./GoFurtherPrimitives";

interface GoFurtherHeroSectionProps {
  offices: OfficeWithPersona[];
  selectedOffice: OfficeWithPersona | null;
  onChangeOffice: (office: OfficeWithPersona | null) => void;
}

const GoFurtherHeroSection: React.FC<GoFurtherHeroSectionProps> = ({ offices, selectedOffice, onChangeOffice }) => (
  <>
    {/* Office selector */}
    <OfficeSelector offices={offices} selectedOffice={selectedOffice} onChangeOffice={onChangeOffice} />

    {/* Hero header */}
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        mt: 8,
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
      }}
    >
      <Container maxWidth="lg" disableGutters sx={{ px: 1 }}>
        <Grid container alignItems="center">
          <Grid item xs sx={{ minWidth: 0 }}>
            <Typography component="h1" sx={{ whiteSpace: "nowrap", fontWeight: FONT_WEIGHT.NORMAL, fontSize: FONT_SIZE.heroTitle, color: TEXT_COLOR.PRIMARY }}>
              <Typography
                component="span"
                sx={{ color: TEXT_COLOR.SUCCESS, fontWeight: FONT_WEIGHT.NORMAL, fontSize: FONT_SIZE.heroTitle }}
              >
                EV
              </Typography>
              で、
              <br />
              LPG同等の稼働・営収を目指せます
            </Typography>
            <Typography sx={{ mt: 2, color: TEXT_COLOR.PRIMARY, fontSize: FONT_SIZE.body1 }}>
              本画面では、EVでLPG同等の稼働・営収を実現するために必要な事を記載しています。EV運用の課題である「充電時間」を克服し、LPG同等を達成できるよう弊社も全力で伴走支援いたします。
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", justifyContent: "flex-end", flexShrink: 0, px: 0, ml: 1 }}>
            <Box
              component="img"
              src="/charging_spot.png"
              alt="Charging EV"
              sx={{
                width: "auto",
                height: "auto",
                maxWidth: 220,
                maxHeight: 180,
                objectFit: "contain",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  </>
);

export default GoFurtherHeroSection;
